(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('incident-department', {
            parent: 'entity',
            url: '/incident-department',
            data: {
                authorities: [],
                pageTitle: 'IncidentDepartments'
            },
            ncyBreadcrumb: {
                label: 'IncidentDepartment'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/incident-department/list/incident-department.html',
                    controller: 'IncidentDepartmentController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                    var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_INCIDENT_DEPARTMENT];
                    return Auth.loadActionsAccess(actions).$promise;
                }]
            },
            onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_INCIDENT_DEPARTMENT, access);
            }]
        });
    }

})();
